import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { CardBody } from "../../../_metronic/_partials/controls";
import { postPartida, updatePartida } from "../../../api/partida";
import { getPartidaCategories } from "../../../api/partidaCategory";
import { getProducts } from "../../../api/product";
import { getProductFamilies } from "../../../api/productFamily";
import { getProductTypes } from "../../../api/productType";
import { getProductUnitTypes } from "../../../api/productUnitType";
import { alertError, alertSuccess } from "../../../utils/logger";
import {
  PARTIDA_REFERENCE_MAX_LENGTH,
  ROLES,
} from "../../../utils/constants";
import ProductContent from "../../modules/ContentManager/products/ProductContent";
import Editor from "../editor/Editor";
import Table, { buttonsStyle } from "../tables/table";
import EntityInfoDialog from "./EntityInfoDialog";
import ProductSelectTableDialog from "./ProductSelectTableDialog";
import { getProductMarcas } from "../../../api/productMarca";
import { getCustomers } from "../../../api/customer";
import CreatePartidaSubcategoryDialog from "./CreatePartidaSubcategoryDialog";
import { getMaterialGroups } from "../../../api/materialGroup";
import MaterialGroupSelectDialog from "./MaterialGroupSelectDialog";

function getEmptyPartida() {
  return {
    referencia: null,
    descripcion: null,
    categoria_id: null,
    categoria_ids: [],
    cliente_id: null,
    concepto: null,
    productos: [],
    agrupaciones_materiales: [],
  };
}

function getProductData(partidaProducts, products) {
  let data = [];

  for (let i = 0; i < partidaProducts.length; ++i) {
    const elem = {};

    const partidaProduct = partidaProducts[i];

    const product = products.find((x) => x?.id === partidaProduct?.producto_id);

    elem.tipoUnidad = product?.tipo_unidad?.descripcion;
    elem.referencia = product?.referencia;
    elem.descripcion = product?.descripcion;
    elem.marca = product?.marca?.nombre;
    elem.familia = product?.familia?.descripcion;
    elem.tipoProducto = product?.tipo_producto?.descripcion;
    elem.precio = (partidaProduct?.es_mano_de_obra ?? product?.tipo_producto?.es_mano_de_obra)
      ? "Coste/hora de la oferta"
      : product?.precio + " €";
    elem.unidades = partidaProduct?.unidades;
    elem.id = product?.id;

    data = data.concat(elem);
  }
  return data;
}

const CreatePartidaDialog = (props) => {
	const {
		title,
		open,
		setOpen,
		onSave,
		defaultCustomerId = null,
		defaultRootCategoryId = null,
		defaultSubcategoryId = null,
		partidaToEdit = null,
	} = props;

  const [partida, setPartida] = useState(getEmptyPartida());

  const [categories, setCategories] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [productFamilies, setProductFamilies] = useState([]);
  const [productMarcas, setProductMarcas] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [productUnitTypes, setProductUnitTypes] = useState([]);
  const [materialGroups, setMaterialGroups] = useState([]);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openProductTableDialog, setOpenProductTableDialog] = useState(false);
  const [openMaterialGroupDialog, setOpenMaterialGroupDialog] = useState(false);
  const [openProductInfoDialog, setOpenProductInfoDialog] = useState(null);
  const [openCreateSubcategoryDialog, setOpenCreateSubcategoryDialog] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );
  const isOfferManager = loggedUser?.role?.rango === ROLES.GESTOR_OFERTAS;

  useEffect(() => {
    if (!open) return;
    let active = true;

    getProductMarcas(loggedUser?.accessToken)
      .then((res) => {
        if (active && res.status === 200) {
          setProductMarcas(res.data);
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener las marcas de productos.",
        });
      });
    getProductFamilies(loggedUser?.accessToken)
      .then((res) => {
        if (active && res.status === 200) {
          setProductFamilies(res.data);
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener las familias de productos.",
        });
      });
    getProductTypes(loggedUser?.accessToken)
      .then((res) => {
        if (active && res.status === 200) {
          setProductTypes(res.data);
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener los tipos de productos.",
        });
      });
    getPartidaCategories(loggedUser?.accessToken)
      .then((res) => {
        if (active && res.status === 200) {
          setCategories(res.data);
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener las categorías.",
        });
        setOpen(false);
      });
    getProductUnitTypes(loggedUser?.accessToken)
      .then((res) => {
        if (active && res.status === 200) {
          setProductUnitTypes(res.data);
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener los tipos de unidades.",
        });
      });
    getProducts(loggedUser?.accessToken)
      .then((res) => {
        if (active && res.status === 200) {
          setProducts(res.data);
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error: error,
          customMessage: "No se han podido obtener los productos.",
        });
        setOpen(false);
      });
    getMaterialGroups(loggedUser?.accessToken).then((res) => {
      if (active) setMaterialGroups(res.data);
    }).catch(() => {});
    getCustomers(loggedUser?.accessToken)
      .then((res) => {
        if (active && res.status === 200) {
          setCustomers(
            (res.data || []).filter(
              (customer) => customer?.activo && customer?.usar_partidas_especificas
            )
          );
        }
      })
      .catch((error) => {
        if (!active) return;
        alertError({
          error,
          customMessage: "No se han podido obtener los clientes disponibles.",
        });
      });
    return () => { active = false; };
  }, [open, loggedUser?.accessToken]);

  useEffect(() => {
    if (open) {
		if (partidaToEdit) {
			const categoryIds = partidaToEdit.categoria_ids || partidaToEdit.categorias?.map((category) => category.id) || [partidaToEdit.categoria?.id].filter(Boolean);
			setPartida({
				...getEmptyPartida(),
				...partidaToEdit,
				categoria_id: partidaToEdit.categoria_id || partidaToEdit.categoria?.id || categoryIds[0] || null,
				categoria_ids: categoryIds,
				productos: (partidaToEdit.productos || []).map((product) => ({
					producto_id: product.producto_id || product.producto?.id,
					unidades: product.unidades,
					es_mano_de_obra: product.es_mano_de_obra,
				})),
				agrupaciones_materiales: partidaToEdit.agrupaciones_materiales || [],
			});
		} else {
			setPartida({
				...getEmptyPartida(),
				cliente_id: defaultCustomerId || null,
				categoria_id: defaultRootCategoryId || defaultSubcategoryId || null,
				categoria_ids: [defaultRootCategoryId, defaultSubcategoryId].filter(Boolean),
			});
		}
    }
  }, [open, defaultCustomerId, defaultRootCategoryId, defaultSubcategoryId, partidaToEdit]);

  useEffect(() => {
    setRefresh(false);
  }, [refresh]);

  function savePartida() {
    const validatePartida = () => {
      let error = "";

      if (!partida?.descripcion) {
        error = "La descripción es obligatoria.";
      } else if (!partida?.referencia) {
        error = "La referencia es obligatoria.";
      } else if (partida.referencia.length > PARTIDA_REFERENCE_MAX_LENGTH) {
        error = `La referencia no puede superar los ${PARTIDA_REFERENCE_MAX_LENGTH} caracteres.`;
      } else if (!partida?.categoria_ids?.length) {
        error = "Debe seleccionar al menos una categoría.";
      } else if (!partida?.concepto) {
        error = "El concepto es obligatorio.";
      } else if (partida?.productos?.some((x) => !x.unidades)) {
        error = "Todos los productos deben tener unidades.";
      }

      if (error) {
        alertError({
          error: error,
        });
        return false;
      }

      return true;
    };

    if (!validatePartida()) {
      return;
    }

	const request = partidaToEdit?.id
		? updatePartida(partidaToEdit.id, partida, loggedUser?.accessToken)
		: postPartida(partida, loggedUser?.accessToken);

	request
      .then((res) => {
		if ([200, 201, 204].includes(res.status)) {
          alertSuccess({
            title: "¡Guardada!",
			customMessage: partidaToEdit
				? "Cambios guardados con éxito."
				: "Partida guardada con éxito.",
          });
          setOpen(false);
		  onSave(res.data?.id || partidaToEdit?.id);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
			customMessage: partidaToEdit
				? "No se han podido guardar los cambios."
				: "No se ha podido guardar la partida.",
        });
      });
  }

  const handleChange = (element) => (event) => {
    setPartida({ ...partida, [element]: event.target.value });
  };

  const handleChangeEditor = (element, value) => {
    if (value?.trim() !== "") {
      setPartida({ ...partida, [element]: value });
    }
  };

  function buttonFormatter(productId) {
    return (
      <>
        <Tooltip title="Eliminar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              let products = [...partida.productos];

              products = products?.filter((x) => x?.producto_id !== productId);

              setPartida({ ...partida, productos: products });

              setRefresh(true);
            }}
          >
            <Delete />
          </Button>
        </Tooltip>
      </>
    );
  }

  function unidadesFormatter(productId) {
    const partidaProduct = partida?.productos?.find(
      (x) => x.producto_id === productId
    );
    const isLabor = partidaProduct?.es_mano_de_obra ?? products.some((product) =>
      product.id === productId && product.tipo_producto?.es_mano_de_obra
    );

    return (
      <input
        style={{ width: "100%" }}
        type="number"
        min={0.01}
        step={0.01}
        value={isLabor ? 1 : partidaProduct?.unidades}
        disabled={isLabor}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          const parsedUnits = Number(String(e.target.value).replace(",", "."));
          let _products = [...partida?.productos];

          const productIndex = _products.findIndex(
            (x) => x.producto_id === productId
          );

          if (productIndex !== -1) {
            _products[productIndex] = {
              ..._products[productIndex],
              unidades: Math.max(0.01, parsedUnits || 0.01),
            };
          }

          setPartida({ ...partida, productos: _products });
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.target.blur();
          }
        }}
        onBlur={() => {
          setRefresh(true);
        }}
      />
    );
  }

  const columns = [
    { dataField: "tipoUnidad", text: "Tipo Unidad", sort: true },
    {
      dataField: "referencia",
      text: "Referencia",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "descripcion",
      text: "Descripción",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "marca",
      text: "Marca",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "familia",
      text: "Família",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "tipoProducto",
      text: "Tipo",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "precio",
      text: "Precio",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "id",
      text: "Unidades",
      sort: true,
      headerAlign: "center",
      align: "center",
      formatter: unidadesFormatter,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ].filter((column) => !isOfferManager || column.dataField !== "precio");

  const selectedCategoryIds = partida?.categoria_ids || [];
  const rootCategories = categories.filter((category) => !category.categoria_padre_id);
  const selectedRoots = rootCategories.filter((category) =>
    selectedCategoryIds.includes(category.id) || categories.some((child) =>
      child.categoria_padre_id === category.id && selectedCategoryIds.includes(child.id)
    )
  );
  const selectedSubcategories = categories.filter((category) =>
    category.categoria_padre_id && selectedCategoryIds.includes(category.id)
  );
  const availableSubcategories = categories.filter((category) =>
    category.categoria_padre_id && selectedRoots.some((root) => root.id === category.categoria_padre_id)
  );
  const setCategorySelection = (roots, subcategories) => {
    const ids = [...new Set([...roots.map((category) => category.id), ...subcategories.map((category) => category.id)])];
    setPartida({ ...partida, categoria_ids: ids, categoria_id: ids[0] || null });
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="table-dialog"
        className="backdrop"
      >
		<DialogTitle id="table-dialog">{title || (partidaToEdit ? "Editar partida" : "Nueva partida")}</DialogTitle>
        <DialogContent>
          <div className="row d-flex align-items-center">
            <div className="col-md-4">
              <TextField
                fullWidth
                id={`descripcion`}
                label="Descripción"
                value={partida.descripcion}
                onChange={handleChange("descripcion")}
                InputLabelProps={{ shrink: true }}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-md-4">
              <TextField
                fullWidth
                id={`referencia`}
                label="Referencia"
                value={partida.referencia}
                onChange={handleChange("referencia")}
                error={(partida?.referencia?.length || 0) > PARTIDA_REFERENCE_MAX_LENGTH}
                helperText={
                  (partida?.referencia?.length || 0) > PARTIDA_REFERENCE_MAX_LENGTH
                    ? `Máximo ${PARTIDA_REFERENCE_MAX_LENGTH} caracteres.`
                    : ""
                }
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-md-4">
              <TextField
                select
                fullWidth
                label="Cliente"
                value={partida.cliente_id || ""}
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (value) => {
                    if (!value) return "General";
                    return customers.find((customer) => customer.id === value)?.nombre || "General";
                  },
                }}
                onChange={(event) =>
                  setPartida({
                    ...partida,
                    cliente_id: event.target.value || null,
                  })
                }
                InputLabelProps={{ shrink: true }}
                margin="normal"
                variant="outlined"
              >
                <MenuItem value="">General</MenuItem>
                {customers.map((customer) => (
                  <MenuItem key={customer.id} value={customer.id}>
                    {customer.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </div>
          <div className="row d-flex align-items-center">
            <div className="col-md-6">
              <Autocomplete
                id="autocomplete-categorias-raiz"
                multiple
                filterSelectedOptions
                options={rootCategories}
                getOptionLabel={(option) => option?.descripcion || ""}
                value={selectedRoots}
                onChange={(event, selected) => {
                  setCategorySelection(
                    selected,
                    selectedSubcategories.filter((subcategory) => selected.some((root) => root.id === subcategory.categoria_padre_id))
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                      label="Categorías"
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                )}
              />
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <Autocomplete
                className="w-100"
                id="autocomplete-subcategorias"
                multiple
                disabled={!selectedRoots.length}
                filterSelectedOptions
                options={availableSubcategories}
                getOptionLabel={(option) => option?.descripcion || ""}
                value={selectedSubcategories}
                onChange={(event, selected) => setCategorySelection(selectedRoots, selected)}
                renderInput={(params) => (
                  <TextField {...params} label="Subcategorías" margin="normal" variant="outlined" InputLabelProps={{ shrink: true }} />
                )}
              />
              <Button
                className="align-self-center ml-2"
                style={{ whiteSpace: "nowrap", flexShrink: 0 }}
                variant="outlined"
                color="primary"
                disabled={selectedRoots.length !== 1}
                onClick={() => setOpenCreateSubcategoryDialog(true)}
              >
                Nueva subcategoría
              </Button>
            </div>
          </div>
          <br />
          <Editor
            body={partida?.concepto || ""}
            setBody={(new_body) => {
              handleChangeEditor("concepto", new_body);
            }}
            className="max-height"
            placeholder={"Introduce el concepto aquí..."}
          />
          <br />
          <div className="d-flex justify-content-between">
            <h4>{"Descompuesto"}</h4>
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setOpenProductTableDialog(true);
                }}
              >
                Añadir productos
              </button>
              <button type="button" className="btn btn-light-primary ml-2" onClick={() => setOpenMaterialGroupDialog(true)}>Añadir agrupación</button>
            </div>
          </div>
          {partida.productos?.length > 0 ? (
            <>
              {!refresh && (
                <Table
                  data={getProductData(partida.productos, products)}
                  columns={columns}
                  rowEvents={{
                    onClick: (e, row, rowIndex) => {
                      const product = products?.find((x) => x.id === row.id);
                      setSelectedProduct(product);
                      setOpenProductInfoDialog(true);
                    },
                  }}
                />
              )}
            </>
          ) : (
            <div>Añada productos para gestionar el descompuesto</div>
          )}
          {(partida.agrupaciones_materiales || []).map((group) => <div key={group.agrupacion_material_original_id} className="mt-3 p-3" style={{ background: "#eef7ff", borderLeft: "4px solid #3699ff" }}><div className="d-flex justify-content-between"><strong>Agrupación: {group.descripcion}</strong><Button color="secondary" size="small" onClick={() => setPartida({ ...partida, agrupaciones_materiales: partida.agrupaciones_materiales.filter((item) => item !== group) })}>Eliminar</Button></div>{(group.productos || []).map((line) => <div key={line.producto_id} className="pl-3">• {line.producto?.descripcion} × {line.unidades}</div>)}</div>)}
        </DialogContent>
        <DialogActions>
          <Button
            className="mr-2"
            onClick={() => {
              setOpen(false);
              setPartida(getEmptyPartida());
            }}
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              savePartida();
            }}
            variant="outlined"
            color="primary"
          >
            Guardar
          </Button>
          <br />
        </DialogActions>
      </Dialog>
      <CreatePartidaSubcategoryDialog
        open={openCreateSubcategoryDialog}
        setOpen={setOpenCreateSubcategoryDialog}
        parentCategory={selectedRoots.length === 1 ? selectedRoots[0] : null}
        onCreated={(subcategory) => {
          setCategories((current) => [...current, subcategory]);
          setCategorySelection(selectedRoots, [...selectedSubcategories, subcategory]);
        }}
      />
      <ProductSelectTableDialog
        title="Productos"
        open={openProductTableDialog}
        setOpen={setOpenProductTableDialog}
        data={products?.filter(
          (x) => ![...partida.productos]?.some((y) => y?.producto_id === x?.id)
        )}
        productMarcas={productMarcas}
        productFamilies={productFamilies}
        productTypes={productTypes}
        productUnitTypes={productUnitTypes}
        initialSelectedProducts={[...partida.productos]?.map(
          (x) => x?.producto_id
        )}
        onSave={(selectedProductIds) => {
          let _products;

          if (!Array.isArray(selectedProductIds)) {
            _products = [
              ...partida.productos,
              {
                producto_id: selectedProductIds,
                unidades: 1,
              },
            ];

            if (!products?.some((x) => x.id === selectedProductIds)) {
              getProducts(loggedUser?.accessToken)
                .then((res) => {
                  setProducts(res.data);
                })
                .catch(() => {});
            }
          } else {
            _products = selectedProductIds.map((productId) => {
              const existingProduct = partida.productos.find(
                (x) => x.producto_id === productId
              );

              return {
                producto_id: productId,
                unidades: existingProduct ? existingProduct.unidades : 1,
                es_mano_de_obra: existingProduct?.es_mano_de_obra,
              };
            });
          }

          setPartida({
            ...partida,
            productos: _products,
          });
        }}
      />
      <MaterialGroupSelectDialog open={openMaterialGroupDialog} setOpen={setOpenMaterialGroupDialog} data={materialGroups} onSave={(ids) => setPartida({ ...partida, agrupaciones_materiales: [...(partida.agrupaciones_materiales || []), ...ids.filter((id) => !(partida.agrupaciones_materiales || []).some((item) => item.agrupacion_material_original_id === id)).map((id, index) => { const group = materialGroups.find((item) => item.id === id); return { agrupacion_material_original_id: group.id, referencia: group.referencia, descripcion: group.descripcion, tipo_unidad_id: group.tipo_unidad_id, unidades: 1, ordinal: (partida.agrupaciones_materiales || []).length + index, productos: (group.productos || []).map((line) => ({ producto_id: line.producto_id, unidades: line.unidades, ordinal: line.ordinal, producto: line.producto })) }; })] })} />
      <EntityInfoDialog
        title={"Producto: " + selectedProduct?.descripcion}
        open={Boolean(openProductInfoDialog)}
        setOpen={setOpenProductInfoDialog}
        content={<ProductContent product={selectedProduct} />}
      />
    </>
  );
};
export default CreatePartidaDialog;
